import React, { useCallback, useEffect } from 'react';

import { Grid } from '@gogame/components';
import { FormField, withForm } from '@gogame/form';

import {
  loadLinksLandings,
  loadLinksLocales,
} from 'scenes/Campaigns/sources/links';

import {
  FILTER_LOCALES,
  FILTER_CONVERSION_PAGE_IDS,
  FILTER_DEPENDENCIES,
} from './constants';

export const TrackingLinksFilters = withForm()(({
  values,
  dirty,
  submitForm,
  applicationId,
  networkId,
}) => {
  useEffect(() => {
    if (dirty && values[FILTER_CONVERSION_PAGE_IDS]) {
      submitForm();
    }
  }, [dirty, values]);

  const loadLinksLandingsWithParams = useCallback(
    (params) =>
      loadLinksLandings({
        ...params,
        applicationIds: applicationId,
        networkIds: networkId,
      }),
    [applicationId, networkId]
  );

  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <FormField.MultiSelect
          padding={'0'}
          label={'Locales'}
          name={FILTER_LOCALES}
          placeholder={'All'}
          source={loadLinksLocales}
        />
      </Grid>
      <Grid item xs={12}>
        <FormField.MultiSelect
          padding={'0'}
          label={'Conversion pages'}
          name={FILTER_CONVERSION_PAGE_IDS}
          placeholder={'All'}
          source={loadLinksLandingsWithParams}
          depends={FILTER_DEPENDENCIES[FILTER_CONVERSION_PAGE_IDS]}
          groupBy={null}
        />
      </Grid>
    </Grid>
  );
});
